<ng-template #settingsTemplate>
    <app-tool-setting label="Tijd">
        <app-check-box
            [(checked)]="showNumbers"
            label="Klok met cijfers"
        ></app-check-box>
    </app-tool-setting>
    <app-tool-setting label="Wijzers">
        <app-check-box
            [(checked)]="showHoursHand"
            label="Kleine Wijzer"
        ></app-check-box>
        <app-check-box
            [(checked)]="showMinutesHand"
            label="Grote Wijzer"
        ></app-check-box>
        <app-check-box
            [(checked)]="showSecondsHand"
            label="Seconden Wijzer"
        ></app-check-box>
    </app-tool-setting>
    <app-tool-setting label="Vergroten">
        <app-radio-input
            [value]="'default'"
            [model]="zoomSize"
            (selected)="setZoomSize('default')"
            >Standaard
        </app-radio-input>
        <app-radio-input
            [value]="'medium'"
            [model]="zoomSize"
            (selected)="setZoomSize('medium')"
            >Groter
        </app-radio-input>
        <app-radio-input
            [value]="'large'"
            [model]="zoomSize"
            (selected)="setZoomSize('large')"
            >Grootst
        </app-radio-input>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        version="1.1"
        class="svg"
        [ngClass]="'svg--' + zoomSize"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 85.039 85.039"
        xml:space="preserve"
    >
        <g class="klok" (mouseup)="clearSelected()">
            <path
                style="fill: #ffffff"
                d="M73.701,42.52c0,17.22-13.959,31.18-31.183,31.18c-17.22,0-31.18-13.96-31.18-31.18
		c0-17.222,13.96-31.181,31.18-31.181C59.742,11.339,73.701,25.298,73.701,42.52z"
            />
            <g>
                <g>
                    <path
                        style="fill: #0090c9"
                        d="M42.519,11.339c-17.192,0-31.18,13.987-31.18,31.18c0,17.193,13.989,31.182,31.18,31.182
				C59.714,73.7,73.7,59.712,73.7,42.519C73.7,25.326,59.714,11.339,42.519,11.339z M73.086,45.842
				c-0.102,0.946-0.245,1.88-0.431,2.798l-1.825-0.422l-0.099,0.422l1.829,0.423c-0.195,0.896-0.424,1.779-0.695,2.644l-1.741-0.59
				l-0.144,0.408l1.746,0.591c-0.293,0.889-0.622,1.76-0.992,2.612l-1.699-0.794l-0.183,0.397l1.704,0.789
				c-0.373,0.826-0.779,1.633-1.22,2.418l-2.851-1.725l-0.336,0.556l2.865,1.729c-0.453,0.768-0.94,1.514-1.457,2.237l-1.644-1.149
				l-0.251,0.354l1.645,1.147c-0.56,0.762-1.155,1.496-1.781,2.202l-1.444-1.382l-0.301,0.312l1.459,1.397
				c-0.615,0.674-1.26,1.319-1.932,1.937l-1.331-1.477l-0.321,0.288l1.331,1.478c-0.688,0.615-1.4,1.201-2.141,1.753l-1.276-1.683
				l-0.346,0.262l1.27,1.671c-0.7,0.506-1.418,0.987-2.16,1.434l-1.809-3.036l-0.558,0.331l1.805,3.028
				c-0.768,0.441-1.556,0.85-2.363,1.225l-0.964-1.8l-0.382,0.204l0.951,1.774c-0.856,0.382-1.732,0.726-2.626,1.03l-0.669-1.923
				l-0.408,0.14l0.665,1.924c-0.928,0.301-1.875,0.557-2.84,0.769l-0.247-2.006l-0.43,0.054l0.25,2.051
				c-0.861,0.177-1.738,0.31-2.623,0.413l-0.102-2.034l-0.43,0.019l0.099,2.069c-0.891,0.091-1.796,0.135-2.708,0.148v-3.482h-0.649
				v3.488c-0.905-0.006-1.8-0.052-2.684-0.136l0.097-1.99l-0.431-0.021l-0.095,1.968c-0.886-0.096-1.761-0.231-2.623-0.401
				l0.244-1.997l-0.43-0.054l-0.24,1.965c-0.965-0.205-1.913-0.453-2.842-0.746l0.66-1.905l-0.409-0.144l-0.661,1.909
				c-0.898-0.297-1.778-0.633-2.637-1.009l0.953-1.779l-0.379-0.204l-0.968,1.805c-0.811-0.368-1.603-0.769-2.374-1.204l1.819-3.056
				l-0.558-0.33l-1.823,3.063c-0.774-0.458-1.525-0.95-2.254-1.472l1.236-1.629l-0.343-0.26l-1.247,1.638
				c-0.741-0.547-1.455-1.128-2.144-1.738l1.358-1.509l-0.322-0.287l-1.362,1.513c-0.68-0.619-1.33-1.271-1.953-1.948l1.483-1.422
				l-0.298-0.311l-1.475,1.41c-0.645-0.722-1.257-1.473-1.832-2.253l1.695-1.183l-0.248-0.354l-1.696,1.187
				c-0.499-0.697-0.973-1.414-1.414-2.152l3.02-1.826l-0.337-0.555l-3.007,1.819c-0.448-0.788-0.862-1.597-1.24-2.427l1.878-0.875
				l-0.182-0.393l-1.874,0.874c-0.376-0.855-0.712-1.731-1.01-2.625l1.937-0.656l-0.139-0.41l-1.938,0.653
				c-0.277-0.871-0.511-1.759-0.71-2.661l2.037-0.468l-0.098-0.42l-2.037,0.468c-0.386-1.877-0.594-3.817-0.62-5.801l3.326,0.022
				l0.003-0.647l-3.333-0.024c0.007-0.88,0.051-1.751,0.131-2.613l1.956,0.205l0.047-0.43l-1.963-0.205
				c0.102-0.951,0.245-1.89,0.432-2.814l1.945,0.448l0.097-0.421l-1.948-0.452c0.195-0.9,0.425-1.786,0.697-2.655l1.862,0.631
				l0.139-0.411l-1.863-0.628c0.294-0.894,0.626-1.77,0.998-2.626l1.812,0.846l0.183-0.393l-1.817-0.847
				c0.374-0.829,0.782-1.638,1.226-2.426l2.96,1.789l0.335-0.555l-2.972-1.797c0.437-0.739,0.905-1.457,1.401-2.155l1.662,1.163
				l0.247-0.354l-1.659-1.159c0.571-0.782,1.179-1.535,1.82-2.258l1.454,1.393l0.3-0.313l-1.469-1.406
				c0.619-0.68,1.27-1.33,1.947-1.952l1.353,1.502l0.321-0.287l-1.354-1.503c0.686-0.613,1.397-1.198,2.136-1.749l1.248,1.642
				l0.345-0.261l-1.24-1.632c0.727-0.526,1.476-1.023,2.248-1.484l1.833,3.079l0.557-0.332l-1.828-3.07
				c0.769-0.438,1.559-0.844,2.368-1.215l0.982,1.834l0.381-0.205l-0.97-1.807c0.859-0.38,1.739-0.721,2.638-1.023l0.676,1.95
				l0.408-0.141l-0.675-1.948c0.932-0.298,1.884-0.552,2.852-0.761l0.245,2.022l0.429-0.053l-0.252-2.062
				c0.863-0.174,1.74-0.308,2.627-0.407l0.1,2.039l0.432-0.021l-0.103-2.067c0.886-0.087,1.785-0.132,2.691-0.142v3.567h0.646
				v-3.567c0.78,0.008,1.552,0.047,2.316,0.112l-0.099,2.025l0.432,0.021l0.096-2.013c0.889,0.088,1.765,0.221,2.63,0.384
				l-0.251,2.06l0.428,0.053l0.248-2.036c0.973,0.197,1.928,0.442,2.865,0.728l-0.69,1.995l0.409,0.141l0.693-2.005
				c0.907,0.292,1.796,0.621,2.665,0.993l-1.012,1.892l0.38,0.203l1.027-1.916c0.815,0.363,1.614,0.756,2.39,1.186l-1.896,3.183
				l0.556,0.333l1.904-3.191c0.79,0.459,1.556,0.952,2.3,1.477l-1.244,1.634l0.345,0.263l1.252-1.646
				c0.747,0.544,1.467,1.121,2.161,1.728l-1.322,1.465l0.319,0.289l1.329-1.472c0.678,0.61,1.326,1.251,1.948,1.919l-1.474,1.408
				l0.299,0.311l1.472-1.404c0.635,0.701,1.237,1.431,1.806,2.188l-1.693,1.184l0.249,0.356l1.698-1.187
				c0.525,0.72,1.023,1.46,1.486,2.225l-2.947,1.782l0.333,0.553l2.936-1.774c0.451,0.783,0.869,1.587,1.252,2.411l-1.82,0.846
				l0.185,0.393l1.813-0.845c0.381,0.852,0.723,1.725,1.026,2.616l-1.891,0.638l0.14,0.41l1.89-0.64
				c0.282,0.868,0.523,1.753,0.727,2.653l-2.007,0.463l0.1,0.421l2.005-0.463c0.197,0.925,0.348,1.867,0.459,2.821l-2.05,0.215
				l0.045,0.432l2.046-0.216c0.094,0.923,0.154,1.856,0.164,2.801L70.014,42.2l0.004,0.649l3.243-0.023
				c-0.009,0.871-0.052,1.733-0.132,2.586l-1.838-0.194l-0.043,0.43L73.086,45.842z M11.925,45.472l0.044,0.428l2.054-0.217
				l-0.045-0.43L11.925,45.472z"
                    />
                </g>
            </g>
        </g>
        <g
            class="cijfers"
            [ngStyle]="{display: !showNumbers ? 'none' : 'block'}"
        >
            <g>
                <path
                    d="M38.566,8.031h1.326V4.155c0-0.187,0.009-0.374,0.009-0.374h-0.017c0,0-0.068,0.136-0.289,0.349l-0.561,0.552l-0.51-0.527
			l1.436-1.394h0.748v5.27h1.309v0.731h-3.451V8.031z"
                />
                <path
                    d="M42.714,8.303c0-2.142,2.941-2.448,2.941-3.858c0-0.595-0.45-0.995-1.079-0.995c-0.791,0-1.216,0.765-1.216,0.765
			l-0.62-0.417c0,0,0.544-1.139,1.896-1.139c1.104,0,1.895,0.688,1.895,1.726c0,1.972-2.864,2.278-2.881,3.646h2.975v0.731h-3.868
			C42.731,8.6,42.714,8.447,42.714,8.303z"
                />
            </g>
            <g>
                <path
                    d="M57.973,12.037h1.326V8.161c0-0.187,0.009-0.374,0.009-0.374H59.29c0,0-0.067,0.136-0.289,0.349L58.44,8.688l-0.51-0.527
			l1.437-1.394h0.748v5.27h1.309v0.731h-3.451V12.037z"
                />
            </g>
            <g>
                <path
                    d="M72.026,26.935c0-2.142,2.94-2.448,2.94-3.858c0-0.595-0.45-0.995-1.079-0.995c-0.791,0-1.216,0.765-1.216,0.765
			l-0.62-0.417c0,0,0.544-1.139,1.896-1.139c1.104,0,1.895,0.688,1.895,1.726c0,1.972-2.864,2.278-2.881,3.646h2.975v0.731h-3.867
			C72.043,27.232,72.026,27.08,72.026,26.935z"
                />
            </g>
            <g>
                <path
                    d="M76.281,43.803c0,0,0.587,0.654,1.453,0.654c0.672,0,1.225-0.45,1.225-1.096c0-0.739-0.655-1.105-1.395-1.105h-0.416
			l-0.195-0.45l1.309-1.539c0.195-0.229,0.374-0.391,0.374-0.391v-0.017c0,0-0.179,0.025-0.51,0.025h-2.031v-0.731h3.586v0.536
			l-1.632,1.878c0.791,0.085,1.76,0.595,1.76,1.759c0,1.028-0.808,1.929-2.04,1.929c-1.224,0-1.946-0.815-1.946-0.815L76.281,43.803
			z"
                />
            </g>
            <g>
                <path
                    d="M59.612,75.573c0,0,0.468,0.646,1.317,0.646c0.706,0,1.317-0.484,1.317-1.215c0-0.723-0.595-1.232-1.368-1.232
			c-0.586,0-1.011,0.297-1.011,0.297l-0.485-0.178l0.298-2.975h3.025v0.73h-2.294l-0.145,1.267
			c-0.009,0.179-0.043,0.314-0.043,0.314h0.017c0,0,0.332-0.188,0.773-0.188c1.267,0,2.091,0.876,2.091,1.955
			c0,1.156-0.909,2.022-2.124,2.022c-1.232,0-1.836-0.832-1.836-0.832L59.612,75.573z"
                />
            </g>
            <g>
                <path
                    d="M40.741,79.262c0-1.538,0.841-3.374,2.703-3.374c0.705,0,1.164,0.247,1.164,0.247l-0.271,0.722
			c0,0-0.382-0.195-0.858-0.195c-1.105,0-1.674,1.021-1.802,2.015h0.017c0.255-0.34,0.799-0.569,1.326-0.569
			c1.139,0,1.895,0.866,1.895,1.98c0,1.181-0.807,2.005-1.929,2.005C41.701,82.092,40.741,80.971,40.741,79.262z M44.081,80.087
			c0-0.731-0.468-1.267-1.232-1.267c-0.68,0-1.224,0.407-1.224,0.841c0,0.782,0.586,1.657,1.352,1.657
			C43.665,81.318,44.081,80.783,44.081,80.087z"
                />
            </g>
            <g>
                <path
                    d="M24.895,72.294c0.17-0.34,0.348-0.553,0.348-0.553v-0.017c0,0-0.136,0.025-0.442,0.025h-2.677v-0.73h4.012v0.577
			l-2.711,5.423h-0.867L24.895,72.294z"
                />
            </g>
            <g>
                <path
                    d="M9.763,59.618c-0.391-0.28-0.671-0.646-0.671-1.198c0-0.799,0.604-1.572,1.87-1.572c1.114,0,1.887,0.62,1.887,1.606
			c0,0.799-0.638,1.479-0.714,1.563c0.459,0.281,0.816,0.655,0.816,1.275c0,0.935-0.807,1.759-2.057,1.759
			c-1.198,0-2.091-0.747-2.091-1.835C8.802,60.299,9.601,59.729,9.763,59.618z M10.383,59.976c-0.196,0.136-0.723,0.544-0.723,1.189
			c0,0.688,0.595,1.131,1.232,1.131c0.629,0,1.19-0.408,1.19-1.028C12.083,60.621,11.19,60.366,10.383,59.976z M11.497,59.687
			c0.093-0.094,0.527-0.553,0.527-1.182c0-0.552-0.442-0.9-1.071-0.9c-0.663,0-1.028,0.374-1.028,0.833
			C9.924,59.1,10.723,59.355,11.497,59.687z"
                />
            </g>
            <g>
                <path
                    d="M5.096,45.367l0.272-0.73c0,0,0.382,0.204,0.858,0.204c1.104,0,1.674-1.02,1.802-2.014H8.011
			c-0.247,0.34-0.799,0.561-1.326,0.561c-1.139,0-1.895-0.858-1.895-1.972c0-1.181,0.807-2.006,1.929-2.006
			c1.275,0,2.244,1.114,2.244,2.831c0,1.538-0.841,3.374-2.703,3.374C5.546,45.614,5.096,45.367,5.096,45.367z M8.079,41.841
			c0-0.782-0.586-1.658-1.351-1.658c-0.697,0-1.105,0.536-1.105,1.232c0,0.731,0.459,1.267,1.232,1.267
			C7.535,42.682,8.079,42.266,8.079,41.841z"
                />
            </g>
            <g>
                <path
                    d="M4.651,26.712h1.326v-3.875c0-0.187,0.009-0.374,0.009-0.374H5.969c0,0-0.068,0.136-0.289,0.349l-0.561,0.552l-0.51-0.527
			l1.436-1.394h0.748v5.27h1.309v0.731H4.651V26.712z"
                />
                <path
                    d="M8.867,24.435c0-1.725,0.518-3.094,2.116-3.094c1.606,0,2.125,1.369,2.125,3.094c0,1.734-0.518,3.111-2.125,3.111
			C9.385,27.545,8.867,26.168,8.867,24.435z M12.25,24.435c0-1.3-0.28-2.32-1.266-2.32c-0.978,0-1.258,1.02-1.258,2.32
			c0,1.309,0.28,2.337,1.258,2.337C11.969,26.772,12.25,25.744,12.25,24.435z"
                />
            </g>
            <g>
                <path
                    d="M19.805,11.973h1.326V8.097c0-0.187,0.009-0.374,0.009-0.374h-0.017c0,0-0.068,0.136-0.289,0.349l-0.561,0.552
			l-0.51-0.527l1.436-1.394h0.748v5.27h1.309v0.731h-3.451V11.973z"
                />
                <path
                    d="M23.961,11.973h1.326V8.097c0-0.187,0.009-0.374,0.009-0.374h-0.017c0,0-0.068,0.136-0.289,0.349l-0.561,0.552
			l-0.51-0.527l1.436-1.394h0.748v5.27h1.309v0.731h-3.451V11.973z"
                />
            </g>
            <g>
                <path
                    d="M71.359,60.523l2.771-3.867h0.96v3.68h0.816v0.714H75.09v1.606h-0.824V61.05h-2.906V60.523z M74.266,60.336v-2.185
			c0-0.28,0.034-0.595,0.034-0.595h-0.017c0,0-0.137,0.28-0.298,0.493l-1.7,2.27v0.017H74.266z"
                />
            </g>
        </g>
        <g class="wijzers">
            @for (step of steps; track step; let i = $index) {
            <ng-container>
                <g
                    class="no-pointer"
                    [attr.style]="'transform: rotate(' + step + 'deg)'"
                >
                    <line
                        (mouseover)="handleHandMove(step)"
                        (pointerup)="clearSelected()"
                        style="
                            fill: none;
                            stroke-opacity: 0;
                            stroke: #ffffff;
                            stroke-width: 0.7718;
                        "
                        x1="42.5"
                        y1="42.5"
                        x2="42.5"
                        y2="0"
                    />
                </g>
            </ng-container>
            } @if (showHoursHand) {
            <g
                class="hour"
                [attr.style]="'transform: rotate(' + clock.hDegrees + 'deg)'"
                (pointerdown)="selectHand(handMoveEnum.hours)"
                (pointerup)="clearSelected()"
            >
                <line
                    style="fill: none; stroke: #000000; stroke-width: 1.2"
                    x1="42.5"
                    y1="42.5"
                    x2="42.5"
                    y2="27.5"
                />
            </g>
            } @if (showMinutesHand) {
            <g
                class="minutes"
                [attr.style]="'transform: rotate(' + clock.mDegrees + 'deg)'"
                (pointerdown)="selectHand(handMoveEnum.minutes)"
                (pointerup)="clearSelected()"
            >
                <line
                    style="fill: none; stroke: #000000; stroke-width: 1.4"
                    x1="42.5"
                    y1="42.5"
                    x2="42.5"
                    y2="19.5"
                />
            </g>
            } @if (showSecondsHand) {
            <g
                class="seconds"
                [attr.style]="'transform: rotate(' + clock.sDegrees + 'deg)'"
                (pointerdown)="selectHand(handMoveEnum.seconds)"
                (pointerup)="clearSelected()"
            >
                <line
                    style="
                        display: inline;
                        fill: none;
                        stroke: #e1042d;
                        stroke-width: 0.8;
                    "
                    x1="42.5"
                    y1="42.5"
                    x2="42.5"
                    y2="17"
                />
            </g>
            }
        </g>
        <g id="Center">
            <path
                d="M44.877,42.52c0,1.324-1.057,2.397-2.357,2.397c-1.303,0-2.357-1.073-2.357-2.397c0-1.322,1.054-2.396,2.357-2.396
		C43.82,40.123,44.877,41.197,44.877,42.52z"
            />
        </g>
    </svg>
</ng-template>
